var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.book)?_c('div',[_c('BookShow',{attrs:{"book":_vm.book}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }